module.exports = __webpack_public_path__ + "static/media/18_B.ccd48926.png";